let categories = [];

// list of order of categories
const categoriesPositions = {
  quick: 0,
  standard: 1,
  fast: 2,
  open: 3,
};

const updateGrid = (data, responseCat) => {
  let columnsHTML = '';
  let colsNo = 0;
  const temp = [];
  const elements = {};
  const responseFacetsHTML = data.facets.vtc_sprinkler_response
				? $($.parseHTML(data.facets.vtc_sprinkler_response))
					.filter('.facetwp-checkbox')
				: [];

	if (!responseFacetsHTML.length) {
    return false;
  }

  $.each(responseFacetsHTML, (index, element) => {
    if ($(element).hasClass('disabled')) {
      return;
    }
    colsNo += 1;
    const columnLabel = $(element).text().split(' ')[0].replace(/[^A-Za-z\s!?]/g, '');
    const responseSpan = '<span class="text-label response">Response</span>';
    const rectangleSpan = '<span class="rectangle"></span>';
    const lowercaseLabel = columnLabel.toLowerCase();

    elements[lowercaseLabel] = categoriesPositions[lowercaseLabel];

    temp[categoriesPositions[lowercaseLabel]] = `
      <div
        class="response-type ${lowercaseLabel}"
        data-ref="${lowercaseLabel}">
        ${rectangleSpan}
        <span class="text-label type">${columnLabel}</span>
        ${responseSpan}
      </div>`;
  });

  columnsHTML = temp.join().replaceAll(',', '');

  if (Object.keys(elements).length) {
      categories = Object.keys(elements).sort((
        a,
        b,
      ) => elements[a] - elements[b]);
  }

  responseCat.find('.row')
    .removeClass((index, css) => (css.match(/\bcols-\S+/g) || []).join(' '))
    .addClass(`cols-${12 / colsNo}`)
    .html(columnsHTML);

  return true;
};

const displayResponseCategories = (fwp, fwpHttp, fwpJson) => {
	const $responseEl = $('#sprinkler_response_categories');

	if (!$responseEl.length) {
    return false;
  }

  const endpoint = (fwp.template === 'wp') ? document.URL : fwpJson.ajaxurl;

  $.ajax({
    url: endpoint,
    type: 'POST',
    dataType: 'json', // better JSON error handling
    async: false,
    contentType: 'application/json',
    data: JSON.stringify({
      action: 'facetwp_refresh',
      data: {
        facets: fwp.facets,
        frozen_facets: fwp.frozen_facets,
        http_params: fwpHttp,
        template: 'wp',
        extras: fwp.extras,
        soft_refresh: fwp.soft_refresh ? 1 : 0,
        is_bfcache: fwp.is_bfcache ? 1 : 0,
        first_load: fwp.loaded ? 0 : 1,
        paged: fwp.paged,
      },
    }),
    success(data) {
      updateGrid(data, $responseEl);
    },
  });
  return true;
};

const groupProductsByResponseCategoryColumn = () => {
    const $grid = $('.fl-module-victaulic-product-grid');
    if (!$grid.length) {
      return false;
    }
    // Hide load more
    $('[data-type="pager"] a.facetwp-load-more').css('display', 'none');

    const elemPerPage = 30;
    const $template = $grid.find('.fl-post-grid.facetwp-template');
    const items = $template.find('.fl-post-column');
    const $loadmore = $('.fake-load-more');
    let gridHTML = '';

    if (!items.length || !categories.length) {
      return false;
    }

    const elementsPerColumn = Math.round(elemPerPage / categories.length);
    categories.forEach((category) => {
      const catName = category.replace(/[^A-Za-z\s!?]/g, '');
      let columnHTML = '';
      const cols = 12 / categories.length;
      const templateCols = `.fl-cols-${cols}[data-categ="${category}"]`;
      if ($template.children(templateCols).length) {
        columnHTML = $template.children(templateCols).html();
      }
      gridHTML += `<div class="fl-cols-${cols} fl-resp-category ${catName}" data-categ="${category}">`;
      let elementCounter = 0;
      $.each(items, (index, item) => {
        $item = $(item);
        if ($item.hasClass(catName)) {
          const columnClass = elementCounter < elementsPerColumn
            ? 'fl-post-column'
            : 'fl-post-column disabled';
          columnHTML += `<div class="${columnClass}">${$item.html()}</div>`;
          elementCounter += 1;
        }
      });
      gridHTML += `${columnHTML}</div>`;
    });
    $template.html(gridHTML);

    if ($('.fl-post-column.disabled').length) {
      $loadmore.css('display', 'inline-block');
    } else {
      $loadmore.css('display', 'none');
    }
    return true;
};

const isMobile = () => $('.sprinkler_filters_responsive_button').is(':visible');

const onClickResponseType = (event) => {
    if (isMobile()) {
        const allRelevantButtons = $('#sprinkler_response_categories .response-type');
        const responseCat = $('.fl-post-grid.facetwp-template .fl-resp-category');
        const target = $(event.currentTarget);
        const ref = target.attr('data-ref');
        const selector = $(`.fl-post-grid.facetwp-template .fl-resp-category[data-categ='${ref}']`);

        allRelevantButtons.removeClass('active');
        target.addClass('active');
        responseCat.addClass('category-disabled');
        selector.removeClass('category-disabled');
    }
    return true;
};

const displayMobileResponseCategories = () => {
  const $responseType = $('#sprinkler_response_categories .response-type');
  const $responseCat = $('.fl-post-grid.facetwp-template .fl-resp-category');
  // verify if we are on mobile resolution
  if (isMobile()) {
    // we remove class active from all  resp categ listing and make only first one active
    $responseType
      .removeClass('active')
      .first()
      .addClass('active');
    $responseCat
      .addClass('category-disabled')
      .first()
      .removeClass('category-disabled');
  } else {
    $responseType.removeClass('active');
    $responseCat.removeClass('category-disabled');
  }

  $responseType.on('click', (event) => onClickResponseType(event));
  return true;
};

const onClickLoadMore = () => {
    const maxElements = Math.round(30 / categories.length);
    const displayType = $('.fl-post-column.disabled').length ? '' : 'none';
    const loadMoreButton = $('[data-type="pager"] a.facetwp-load-more');
    const dummy = $('.fake-load-more');
		const fwp = window.FWP;
    const fwpCount = (fwp.settings.pager.page * fwp.settings.pager.per_page) - 10;

    if (categories && categories.length) {
        categories.forEach((categ) => {
            const disabled = $(`[data-categ="${categ}"] .fl-post-column.disabled`);
            if (disabled.length) {
                $.each(disabled, (index, element) => {
                    if (index < maxElements) {
                        $(element).removeClass('disabled');
                    }
                });
            }
        });

        dummy.css('display', displayType);
        if (
            $('.fl-post-column:not(.disabled)').length >= fwpCount
                && !$('.fl-post-column.disabled').length
        ) {
            dummy.css('display', 'none');
            loadMoreButton.css('display', 'inline-block');
        } else {
            loadMoreButton.css('display', 'none');
        }
    }
    return true;
};

const onSprinklerResponsiveClick = (event) => {
  const $this = $(event.currentTarget);
  // Toggle responsive button
  $this.toggleClass('active');
  $this
    .parents('.fl-module-victaulic-product-facets')
    .toggleClass('active');
  // Open filters
  $('#sprinkler_filters').toggleClass('mobile_active');
};

const onFilterSelectClick = (event) => {
  const facet = $(event.currentTarget).attr('data-facet');
  const target = $(`.filter-wrapper[data-facet="${facet}"]`);

  if (target.hasClass('active')) {
    target.removeClass('active');
  } else {
    target.addClass('active');
  }
};

const onWindowResize = () => {
    displayMobileResponseCategories();
    return true;
};

const addSeoTagsToFacetPagination = () => {
    // This matches the first integer.  Page 124 of 342 => 124
    if ($('.facetwp-pager-label').length !== 0) {
      const currentPage = $('.facetwp-pager-label')
        .text()
        .match(/^\d+|\d+\b|\d+(?=\w)/g)
        .map((v) => +v)[0];
      const pages = $('.facetwp-pager .facetwp-page');

      $(pages).each((index, el) => {
        const that = $(el);
        that.attr('role', 'link').attr('tabindex', 0);
        const page = Number(that.data('page'));
        if (page === currentPage + 1) {
          that.attr('rel', 'next');
        } else if (page === currentPage - 1) {
          that.attr('rel', 'prev');
        }
      });
    }
    return true;
};

const onFacetWPRefresh = () => {
    const facetWPPager = $('.facetwp-pager');
    facetWPPager.find('.prev').html('Prev');
    facetWPPager.find('.next').html('Next');
    facetWPPager.find('.last-page').html('Last');
    return true;
};

const onFacetWPLoaded = () => {
  const url = window.location.href;
  // Scroll top
	$('html, body').animate(
			{
				scrollTop: $('body').offset().top,
			},
			500,
	);
  // Hide spinner
	$('.spinner-wrapper').css('display', 'none');

  // Show clear filters button if there is a parameter.
	if (url.includes('?')) {
			$('.clear_filters').css('display', 'inline-block');
	}

  $('.sprinkler_filters_responsive_button').on('click', (event) => onSprinklerResponsiveClick(event));

  // Open facets
  $('.filter-wrapper .select').on('click', (event) => onFilterSelectClick(event));

  displayResponseCategories(
    window.FWP,
    window.FWP_HTTP,
    window.FWP_JSON,
  );
  displayMobileResponseCategories();
  groupProductsByResponseCategoryColumn();
  addSeoTagsToFacetPagination();

  // Update Count
  $('.js-product-count').text(`(${window.FWP.settings.pager.total_rows})`);

};

(($) => {
  $(document).on('facetwp-loaded', onFacetWPLoaded);
  $(document).on('facetwp-refresh', onFacetWPRefresh);
  $('.fake-load-more').on('click', onClickLoadMore);
  $(window).on('resize', onWindowResize);
})(jQuery);
